function SecondPillarSelect(config, renderer) {
  const errorMessagesTemplate = Handlebars.compile($('#error-messages-partial').html())

  let defaultFrom
  let defaultTo
  let distributionRows
  let secondPillar

  this.init = function (urlParams) {
    secondPillar = session.pension.secondPillar
    defaultTo = urlParams.isin || Recommendations.secondPillar[session.pension.ageGroup][0].isin
    distributionRows = urlParams.activeOnly ? [] : initialDistribution(defaultTo, !!urlParams.isin);
    defaultFrom = distributionRows.length ? distributionRows[0].from : undefined;

    return {
      isin: urlParams.isin,
      activeFunds: secondPillar.activeFunds,
      activeFundIsin: secondPillar.activeFunds[0] ? secondPillar.activeFunds[0].fund.isin : "",
      activeFundCandidates: config.canAssignPiaAsActiveFund ? availableFunds() : fundsView(Funds.secondPillar),
      pension: secondPillar,
      distributionRows: distributionRows,
      showSelectFundOption: false
    }
  }

  function investmentAccountsView(investmentAccounts) {
    return investmentAccounts.map(investmentAccountView).sortBy('name')
  }

  function investmentAccountView(investmentAccount) {
    return {
      isin: investmentAccount.number,
      name: investmentAccount.operator + ' ' + investmentAccount.number
    }
  }

  function fundsView(funds) {
    return Object.keys(funds).map(isin => {
      return {
        isin: funds[isin].isin,
        name: funds[isin].name
      }
    })
  }

  this.done = function () {
    drawDistributionRows()
    addHandlers()
  }

  function addHandlers() {
    const distributionBlock = $('#distribution')
    distributionBlock.on('change', '[name="from"]', updateDistributionRowFromFund)
    distributionBlock.on('change', '[name="to"]', updateDistributionRowToFund)
    distributionBlock.on('change', '[name="percentage"]', updateDistributionRowPercentage)
    distributionBlock.on('click', '.delete', deleteDistributionRow)

    $('#add-distribution-row').click(addDistributionRow)
    $('#delete-all').click(deleteAllDistributionRows)
    $('#consent').click(function () {
      if ($(this).is(':checked')) $('#submit').removeAttr('disabled')
      else $('#submit').attr('disabled', 'disabled')
    })
    $('#application-form').submit(submit)
  }

  function submit(e) {
    e.preventDefault()

    return $.post('/application/second-pillar/validate', {
      distributionRows: JSON.stringify(distributionRows),
      newFund: $('#new-fund').val()
    })
      .done(function(response) {
        sessionStorage.setItem('secondPillarApplication', JSON.stringify({
          distributionRows: distributionRows,
          newFund: $('#new-fund').val()
        }))

        location.href = '#second-pillar-application'
      })
      .fail(function (xhr) {
        Logger.error('Application error: ' + xhr.responseText);
        drawErrorMessages(xhr.responseJSON.validationErrors)
      })
  }

  function drawErrorMessages(errorMessages) {
    const message = $('#error-messages').empty()
    message.append(errorMessagesTemplate({errorMessages: buildMessages(errorMessages)}))
  }

  function buildMessages(errorMessages) {
    const secondPillarFunds = secondPillar.assets
      .map(asset => asset.fund)
      .reduce((memo, fund) => {
        memo[fund.isin] = fund;
        return memo;
      }, {});

    return errorMessages.reduce(function (memo, e) {
      memo.push({
        name: (Funds.secondPillar[e.isin] || secondPillarFunds[e.isin] || {}).name,
        message: e.message,
        error_label: Labels['secondPillar-application-' + e.message.toLowerCase()]
      })
      return memo
    }, [])
  }

  function availableFunds() {
    return investmentAccountsView(session.pension.investmentAccounts.accounts).concat(fundsView(Funds.secondPillar))
  }

  function drawDistributionRows() {
    $('#distribution').html(renderer.template('distribution-partial-second')({
      distributionRows: distributionRows.map(function(row) {
        return {
          assets: secondPillar.assets,
          funds: availableFunds(),
          from: row.from,
          to: row.to,
          percentage: row.percentage,
          percentageError: !isValidPercentage(row.percentage),
          units: row.units,
          showSelectFundOption: row.showSelectFundOption
        }
      })
    }))
  }

  function initialDistribution(isin, suggested) {
    if (secondPillar.activeFunds.length === 0) return [];
    return secondPillar.assets.reduce(function (memo, a) {
      const suggestSellingRecommendation = suggested && isin === a.fund.isin
      if (suggestSellingRecommendation) return memo
      memo.push(
        {
          from: a.fund.isin,
          percentage: 100,
          to: isin
        })
      return memo
    }, [])
  }

  function rowIndex(event) {
    return $(event.target).closest('.row').data('rowIndex')
  }

  function row(event) {
    return distributionRows[rowIndex(event)]
  }

  function updateDistributionRowFromFund(event) {
    row(event)['from'] = $(event.target).val()
    drawDistributionRows()
  }
  function updateDistributionRowToFund(event) {
    row(event)['to'] = $(event.target).val()
    drawDistributionRows()
  }
  function updateDistributionRowPercentage(event) {
    row(event)['percentage'] = parseInt($(event.target).val())
    drawDistributionRows()
  }

  function deleteDistributionRow(event) {
    distributionRows.splice(rowIndex(event), 1)
    drawDistributionRows()
  }

  function deleteAllDistributionRows() {
    distributionRows = []
    drawDistributionRows()
  }

  function addDistributionRow() {
    distributionRows.push({from: defaultFrom, percentage: 100, to: defaultTo})
    drawDistributionRows()
  }

  function isValidPercentage(value) {
    return !isNaN(value) && value >= 0 && value <= 100
  }
}
